// extracted by mini-css-extract-plugin
export default {"gridRow":"TableRow_gridRow__XZkyn","headerRow":"TableRow_headerRow__RcWOl","bodyRow":"TableRow_bodyRow__mWUjN"};